import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConfigProvider, Select, DatePicker, Input, Button, Row, Col, message } from 'antd';
import InfiniteScroll from 'react-awesome-infinite-scroll';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import api from '@api/api';
const { Option } = Select;



const OrderItem = (props) => {
    const navigate = useNavigate();
    const {item2} = props

    return (
        <div className={styles.OrderItem} onClick={() => navigate("/home/homemain/image_service/skuList", { state: { title: item2.idx, id: item2.id }})}>
            <div className={`${styles.OrderItem_} ${item2.status == 1?styles.OrderItem_1:item2.status == 2?styles.OrderItem_2: item2.status == 3?styles.OrderItem_3: styles.OrderItem_5}`}>
                <div className={styles.img_1_box}>
                    <img src={item2.cover + '?x-oss-process=image/resize,w_800/quality,q_90/format,webp'} alt="" />
                </div>
            </div>
            <div className={styles.OrderItem_title}>{item2.idx}</div>
        </div>
    );
}

export default OrderItem